import { createSlice } from '@reduxjs/toolkit';

const dataSlice = createSlice({
  name: 'quickPanel/data',
  initialState: null,
  reducers: {},
  extraReducers: {},
});

export default dataSlice.reducer;
